import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'

import style from './cards.sass'

@inject('store') @observer
class Cards extends Component {
  render() {
    const {paperTrading} = this.props.store
    const {realized_pnl, unrealized_pnl, pnl, total_positions_amount} = paperTrading.session
    return(
      <div styleName='wrapper'>
        <div className='card'>
          <p>Realized PnL</p>
          <h3>{formatCurrency(realized_pnl)}</h3>
        </div>
        <div className='card'>
          <p>Unrealized PnL</p>
          <h3>{formatCurrency(unrealized_pnl)}</h3>
        </div>
        <div className='card'>
          <p>Total PnL</p>
          <h3>{formatCurrency(pnl)}</h3>
        </div>
        <div className='card'>
          <p>Position</p>
          <h3>{total_positions_amount || '-'}</h3>
        </div>
      </div>
    )
  }
}

export default Cards

const formatCurrency = (value) => {
  if (typeof value === 'undefined') {
    return '-'
  }
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  })
}
